import { urljoin as _u } from 'utils'
import {
  opsBasePath,
  basePath,
} from './urls'

// Used when linking to these pages from other pages.

export const OPS_SOLUTION_PATHS = {
  LIST                          :_u(opsBasePath),
  FOR_STARTUP_FOUNDERS          :_u(opsBasePath, '/for-startup-founders'),
  FIND_CANDIDATES_FOR_OPEN_ROLES:_u(opsBasePath, '/find-candidates-for-open-roles'),
  FIND_INFLUENCERS              :_u(opsBasePath, '/find-influencers'),
  FIND_ANGEL_INVESTORS          :_u(opsBasePath, '/find-angel-investors'),
  B2B_DATA_ENRICHMENT           :_u(opsBasePath, '/b2b-data-enrichment'),
  B2B_LEAD_GENERATION           :_u(opsBasePath, '/b2b-lead-generation'),
  MARKET_RESEARCH               :_u(opsBasePath, '/market-research'),
  DATA_MIGRATION                :_u(opsBasePath, '/data-migration'),
  FIND_VC_INVESTORS             :_u(opsBasePath, '/find-vc-investors'),
}

export const USE_CASE_PATHS = {
  RLHF                         :_u(basePath, '/rlhf'),
  SIDE_BY_SIDE_RL              :_u(basePath, '/reinforcement-learning'),
  ORIGINAL_CONTENT             :_u(basePath, '/original-content-generation'),
  CREATIVE_HALLUCINATION       :_u(basePath, '/llm-hallucination-testing'),
  SAFETY_ETHICS_COMPLIANCE     :_u(basePath, '/ai-safety-ethics-training'),
  HONESTY_FACTUALITY_TRAINING  :_u(basePath, '/ai-factuality-training'),
  LLM_PROMPTING                :_u(basePath, '/llm-prompting'),
  CLASSIFICATION               :_u(basePath, '/data-classification-and-indexing'),
  ENGINE_ANNOTATION            :_u(basePath, '/engine-annotation'),
  LLM_FLUENCY_RELEVANCY_GRADING:_u(basePath, '/llm-fluency-relevancy-grading'),
  CHAIN_OF_THOUGHT_REASONING   :_u(basePath, '/chain-of-thought-reasoning'),
}
